module.exports = __webpack_public_path__ + "media/images/flags/16/Indonesia-fb52a3472ad28a9be2444a6e7c554691.png";